import script from "./BaseFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFooter.vue?vue&type=script&setup=true&lang=js"

import "./BaseFooter.vue?vue&type=style&index=0&id=ed77d460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed77d460"]])

export default __exports__